"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var preOrderOnlineExternal = {
    PRE_ORDER_ONLINE_EXTERNAL: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query PreOrder($dealId: String!, $postCode: String) {\n      preOrderOnlineExternal(dealId: $dealId, postCode: $postCode)\n    }\n  "], ["\n    query PreOrder($dealId: String!, $postCode: String) {\n      preOrderOnlineExternal(dealId: $dealId, postCode: $postCode)\n    }\n  "]))),
};
exports.default = preOrderOnlineExternal;
var templateObject_1;
